import usePrivateLink from "../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { Link } from "react-router-dom";
import { formatDate, ToastMain ,SweetAlertShow} from "../master/Master";
import { getSessions } from "../../api/SessionsService";
import { StaffList } from "../../api/Staff";

export default function StaffSetting() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [staffs, setStaffs] = useState("");
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSessions] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [error, setError] = useState('');


  const getSession = async () => {
    setLoading(true)
    try {
      const response = await getSessions();
      if (response?.data?.status) {

        const activeSession = response?.data?.data.find(
          (session) => session.status === "1"
        );
        setSelectedSessions(activeSession.id);
        setSessions(response?.data?.data);
        // setSessions(activeSessions);
      } else {
        setError("Failed to fetch session?.");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false)
    }
  };

  const getStaffs = async () => {
    const addUrl = `&session_id=${selectedSession}`
    setLoading(true);
    try {
      const response = await StaffList(addUrl);
      if (response.data.status) {
        setStaffs(response?.data?.data);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });

      SweetAlertShow('error','Error ', error?.response?.data?.message ??   error?.response?.message 
      )
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  useEffect(() => {
    if (selectedSession) {
      getStaffs();
    }
  }, [selectedSession])
return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="row">
                      <div className="col">
                        <h4 className="text-primary"> Staff Settings</h4>
                      </div>
                      <div className="col text-end">
                        
                        {hasAccess('/staff/add') && (
                            <Link
                              to={`/staff/setting`}
                              className="btn btn-sm btn-primary ms-2"
                            >
                              {/* <i className="bi bi-plus-circle me-2"></i> */}
                              Staff Settings
                            </Link>)}
                        
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-5 mb-3">
                        <div className="form-floating form-floating-outline">
                          <select className="form-select" name="session" value={selectedSession} onChange={(e) => setSelectedSessions(e.target.value)}>
                            {/* <option value="">Select Session</option> */}
                            {sessions?.map((session) => (
                              <option
                                key={session?.id}
                                value={session?.id}
                              >
                                {session?.session}:{session?.status == '1' ? 'Active' : ' Inactive'}
                                {/* Show "2023-24" */}
                              </option>
                            ))}
                          </select>
                          <label>Filter Session</label>
                        </div>
                      </div>

                      <div className="col-12 d-flex gap-2 flex-wrap">
                        <button
                          className={`btn btn-sm ${selectedType == null
                            ? "btn-primary"
                            : "btn-label-primary"
                            } me-2`}
                          onClick={() => {
                            setSelectedType("");
                          }}
                        >
                          All
                        </button>
                        <button
                          className={`btn btn-sm ${selectedType == "1"
                            ? "btn-primary"
                            : "btn-label-primary"
                            } me-2`}
                          onClick={() => {
                            setSelectedType("1");
                          }}
                        >
                          Active
                        </button>

                        <button
                          className={`btn btn-sm ${selectedType == "2"
                            ? "btn-primary"
                            : "btn-label-primary"
                            }`}
                          onClick={() => {
                            setSelectedType("2");
                          }}
                        >
                          Inactive
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-hover text-center align-middle">
                        <thead className="table-label-primary">
                          <tr>
                            <th>#</th>
                            <th>Staff ID</th>
                            <th>Name</th>
                            <th>Mobile No</th>
                            <th>Joining Date</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {staffs?.data?.map((item, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{item.staff_id}</td>
                              <td className="text-primary fw-semibold">
                                {item.name}
                              </td>
                              <td>{item.phone}</td>
                              <td>{formatDate(item?.join_date)}</td>
                              <td>
                                {hasAccess('/staff/status/update') && (
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input fs-4"
                                        type="checkbox"
                                        role="switch"
                                        id="switchCheckDefault"
                                        checked={item?.status == "1"}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="switchCheckDefault"
                                      >
                                        {item?.status == "1"
                                          ? "Active"
                                          : "Inactive"}
                                      </label>
                                    </div>
                                  )}
                              </td>

                              <td>
                                {hasAccess('/teachers/view/:id') && (
                                    <Link
                                      to={`/teachers/view/${item?.id}`}
                                      className="btn btn-sm btn-outline-primary mx-1"
                                    >
                                      <i className="bi bi-eye-fill"></i>
                                    </Link>)}

                                {hasAccess('/staff/update') && (
                                    <Link
                                      to={`/staff/update?id=${item?.id}`}
                                      className="btn btn-sm btn-outline-info mx-1"
                                    >
                                      <i className="bi bi-pen-fill"></i>
                                    </Link>
                                  )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
